import {
  ICountryAndDialCode,
  ICountryStoneinnoDetail,
  IPasswordUrlResponse,
  IRegisterParams,
  IResetPasswordParams
} from '@aqx-core/common/api/account';
import { request } from '@aqx-core/common/request';

export default {
  countryAndDialCode: () => request.get<ICountryAndDialCode[]>('/api/account/v1/country'),
  resetPassword: (params: IResetPasswordParams) => request.post<boolean>('/api/account/v1/password/reset', params),
  register: (params: IRegisterParams) => request.post<string>('/api/account/v1/register', params),
  stoneinnoCountry: () => request.get<ICountryStoneinnoDetail[]>('/api/account/v1/sicountry'),
  deposit: () => request.get<number>('/api/account/v1/deposit'),
  getCountryAndDialCodes: () => request.get<ICountryAndDialCode[]>('/api/account/v1/country'),
  getStoneinnoCountryAndDialCodes: () => request.get<ICountryStoneinnoDetail[]>('/api/account/v1/sicountry'),
  getAccountDeposit: () => request.get<number>('/api/account/v1/deposit'),
  getPasswordUrl: () => request.get<IPasswordUrlResponse>('/api/account/v1/password/url')
};
